import { render, staticRenderFns } from "./RegisterStatic.vue?vue&type=template&id=5434352d&"
import script from "./RegisterStatic.vue?vue&type=script&lang=js&"
export * from "./RegisterStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports